export default __webpack_public_path__ + "static/middlebury-08bc7d9000fa5029adab3b5c61d92bb0.png";